import React, { Component } from 'react';
import {Avatar, Button, Divider} from "antd";

const ENV_TEXT_MAP = {
    production: '生产环境',
    preview: '待发布环境',
    test: '测试环境',
    development: '开发环境'
};

const getEnvText = () => {
    const env = process.env.REACT_APP_ENV || 'development';
    return ENV_TEXT_MAP[env] || ENV_TEXT_MAP.development;
};

class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {
            myObject:props.myObject,
            data: null,
            loading: true,
        };
    }

    // 组件挂载后调用
    componentDidMount() {
        console.log('Component did mount');
        // 模拟请求数据
        setTimeout(() => {
            this.setState({ data: 'Hello, React!', loading: false });
        }, 2000);
    }

    // 组件更新后调用
    componentDidUpdate(prevProps, prevState) {
        if (prevState.data !== this.state.data) {
            console.log('Component did update with new data');
        }
    }

    // 组件卸载前调用
    componentWillUnmount() {
        console.log('Component will unmount');
        // 清理副作用，取消订阅或清理定时器等
    }

    render() {
        const { data, loading } = this.state;

        return (
            <div>
                <h1>环境:{getEnvText()}</h1>
                {loading ? (
                    <p>Loading...</p>
                ) : (
                    <p>Data fetched: {data}</p>
                )}
                <Button type="primary">类组件{JSON.stringify(this.state.myObject)}</Button>
                <Divider></Divider>
                <Avatar></Avatar>
            </div>
        );
    }
}

export default Home;
